export default "__VITE_ASSET__CZWvktkO__"